import { combineReducers } from 'redux';
import authReducer from './authReducer';
import countriesReducer from './countriesReducer';
import dynastiesReducer from './dynastiesReducer';
import appReducer from './appReducer';
import tagsReducer from './tagsReducer';
// eslint-disable-next-line import/no-named-default
import { default as BuildingComponentInstance } from './instances/componentsReducer';
// eslint-disable-next-line import/no-named-default
import { default as BuildingElementInstance } from './instances/elementsReducer';
import buildingsReducer from './instances/buildingsReducer';
import productsReducer from './instances/productsReducer';
import contextsReducer from './instances/contextsReducer';
import characteristicsReducer from './instances/characteristicsReducer';
import usersReducer from './usersReducer';

export default combineReducers({
  auth: authReducer,
  countries: countriesReducer,
  dynasties: dynastiesReducer,
  app: appReducer,
  tags: tagsReducer,
  buildingComponentInstance: BuildingComponentInstance,
  buildingElementInstance: BuildingElementInstance,
  buildings: buildingsReducer,
  products: productsReducer,
  contexts: contextsReducer,
  characteristics: characteristicsReducer,
  users: usersReducer,
});
